import { map } from 'nanostores';
import { importModifications, importPromise } from './importStore';
import { workbenchStore } from '~/lib/stores/workbench';
import { webcontainer } from '~/lib/webcontainer';
import type { Message } from '~/types/chat';

export interface DeploymentInfo {
  site_url: string;
  kind: 'static-hosting' | 'netlify';
  is_custom_domain: boolean;
  default_domain?: string;
  updated_at?: string;
}

interface ImportInfo {
  statusMessage: string;
  messages: Message[];
  chatLoadingStatus: 'LOADING' | 'LOADED' | 'DONE';
  deploymentInfo: DeploymentInfo | undefined;
}

export const importStore = map<ImportInfo>({
  statusMessage: '',
  messages: [],
  chatLoadingStatus: 'LOADING',
  deploymentInfo: undefined,
});

export async function waitForProjectImport() {
  return Promise.all([waitForProjectImportFiles(), importModifications.promise]);
}

/**
 * The "project import" task used to be just about getting some files.
 * Now it is split in two phases. Most consumers should only care about
 * the `waitForImport()` "task". But some consumers (notably, GH sync) do
 * care about having the initial files vs. patching those files for reasons
 * (e.g. overwriting with a git clone).
 */
export async function waitForProjectImportFiles() {
  return Promise.all([importPromise.promise, webcontainer]).then(() => {
    return workbenchStore.waitForImport();
  });
}
